import Regimens from '../../../../components/Regimens'
import { SupplementRegimensProps } from '../utils/types'

export const SupplementRegimens = ({ lists }: SupplementRegimensProps) => {
  return (
    <Regimens
      recordLabel='Supplement'
      amountEnabled
      frequencyEnabled
      methodEnabled
      lists={lists}
    />
  )
}
